import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/shutterstock_362816681-min.jpg")